<template>
  <div class="offline-device-item tb"
  v-if="funcView.all_offline_device_list ||funcView.my_offline_device_list"
  >
    <custom-tab
      :value="type"
      :list="typeData"
      class="tab"
      @input="onTabChange"
    ></custom-tab>
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 导出excel -->
        <el-form-item style="float: right; margin-right: 0" v-if="(funcView.all_offline_device_export&& type === 1) ||(funcView.my_offline_device_export&& type === 2) ">
          <el-button
            class="table-set"
            style="vertical-align: top"
            @click="exportTable"
          ><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right" :class="{'mr-0':!((funcView.all_offline_device_export&& type === 1) ||(funcView.my_offline_device_export&& type === 2)) }">
          <search-input
            v-model="formSearch.keyword"
            @fetch="onPageChange({ page: 1 })"
            :placeholder="$t('asm_offline_device_item.jshhtbhaldh')"
          ></search-input>
        </el-form-item>
        <!-- 更多搜索 -->
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <!-- 产品型号 -->
        <el-form-item :label="$t('asm_offline_device_item.chan_pin_xing_hao')">
          <el-input v-model="formSearch.productCode"></el-input>
        </el-form-item>
        <!-- 离线天数（注：大于 7 天，大于 30 天，大于 60 天 -->
        <el-form-item :label="$t('asm_offline_device_item.li_xian_tian_shu')">
          <el-select
            v-model="formSearch.offlineDays"
            clearable
          >
            <el-option
              v-for="(item,index) in offlineDaysData"
              :key="index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 租赁方  -->
        <el-form-item :label="$t('asm_offline_device_item.zu_lin_fang')">
          <el-input
            v-model="formSearch.customerName"
            clearable
          ></el-input>
        </el-form-item>
        <!-- 项目  -->
        <el-form-item :label="$t('asm_offline_device_item.xiang_mu')">
          <el-input
            v-model="formSearch.locationName"
            clearable
          ></el-input>
        </el-form-item>
        <!-- 售后公司  -->
        <el-form-item :label="$t('asm_offline_device_item.shou_hou_gong_si')">
          <el-input
            v-model="formSearch.afterServiceName"
            clearable
          ></el-input>
        </el-form-item>
        <!-- 代理公司  -->
        <el-form-item :label="$t('asm_offline_device_item.dai_li_gong_si')">
          <el-input
            v-model="formSearch.agentCoName"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        height="100%"
        :data="tableList"
        :column="tableColumn"
        @sort="sortChange"
        @filter="filterChange"
        index
        :slots="['action']"
      >
        <template v-slot:action="scope">
          <span>
            <!-- 艾玛说，添加了案例后，还可以继续添加 -->
            <el-button
              type="text"
              size="mini"
              @click="addCase(scope.row)"
               v-if="(funcView.all_offline_device_add&& type === 1)|| (funcView.my_offline_device_add&& type === 2)"
            >{{ $t('asm_offline_device_item.tian_jia_an_li') }}</el-button>
            <el-button
              type="text"
              size="mini"
              v-if="(funcView.all_offline_device_edit&& type === 1)|| (funcView.my_offline_device_edit&& type === 2)"
              @click="offlineSetting(scope.row)"
            >{{ $t('asm_offline_device_item.li_xian_she_zhi') }}</el-button>
          </span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <add-case-dialog
      v-if="addCaseVisible"
      @close="addCaseVisible=false"
      :model="addCaseModel"
      @success="getTableList"
      type="offlineDevice"
    ></add-case-dialog>
    <offline-setting-dialog
      v-if="offlineSettingVisible"
      @close="offlineSettingVisible=false"
      :model="offlineSettingModel"
      @success="getTableList"
      type="offlineDevice"
    ></offline-setting-dialog>
  </div>
</template>

<script>
import qs from 'qs';
import apis from '@/utils/apis';
import addCaseDialog from './add_case_dialog.vue';
import offlineSettingDialog from './offline_setting_dialog.vue';

export default {
  name: '',
  mixins: [],
  components: {
    addCaseDialog,
    offlineSettingDialog
  },
  props: {
    // 1 - 组织设备  2 - 我的设备
    type: Number,
  },
  data() {
    return {
      link: null,
      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,

        productCode: '',
        // 离线天数
        offlineDays: '',
        // 租赁方
        customerName: '',
        // 项目
        locationName: '',
        // 售后公司
        afterServiceName: '',
        // 代理公司
        agentCoName: '',


      },
      tableList: [],
      totalRows: null,
      tableCode: 'offline_device_list',
      addCaseVisible: false,
      addCaseModel: {},
      offlineSettingVisible: false,
      offlineSettingModel: {},
    };
  },
  computed: {
    offlineDaysData() {
      return [
        {
          label: this.$t('asm_offline_device_item.da_yu7tian'),
          value: 7
        },
        {
          label: this.$t('asm_offline_device_item.da_yu30tian'),
          value: 30
        },
        {
          label: this.$t('asm_offline_device_item.da_yu60tian'),
          value: 60
        }
      ];
    },
    typeData() {
      const typeMap = [];
      if (this.funcView.all_offline_device_list) {
        typeMap.push({
          value: 1,
          name: this.$t('asm_offline_device_item.zu_zhi_she_bei')
        });
      }
      if (this.funcView.my_offline_device_list) {
        typeMap.push({
          value: 2,
          name: this.$t('asm_offline_device_item.wo_de_she_bei')
        });
      }
      return typeMap;
    },
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    // 离线设置
    offlineSetting(item) {
      this.offlineSettingModel = {
        data: item,
      };
      this.offlineSettingVisible = true;
    },
    exportTable() {
      const reqUrl = this.type === 1 ? apis.DmsDeviceOfflineOrgExport : apis.DmsDeviceOfflineMyselfExport;
      // const reqData = {
      //   ...this.formSearch
      // };
      // delete reqData.pageSize;
      // delete reqData.pageNum;
      // this.$postJSON(reqUrl, reqData);
      const param = {};
      Object.keys(this.formSearch).forEach((key) => {
        const val = this.formSearch[key];
        if (val) {
          param[key] = val;
        }
      });
      delete param.pageSize;
      delete param.pageNum;

      const pathParms = qs.stringify(param, { arrayFormat: 'repeat' });
      const headerList = this.tableColumn
        .filter(t => t.isExport)
        .map(i => ({ columnCode: i.columnCode, columnName: i.columnName, width: i.width, isFormat: i.isFormat, formatRule: i.formatRule, dicGroup: i.dicGroup }));
      const reqData = {
        exportName: this.type === 1 ? this.$t('asm_offline_device_item.zu_zhi_she_bei') : this.$t('asm_offline_device_item.wo_de_she_bei'),
        headerList: headerList,
      };

      this.$exportFliePost(`${reqUrl}?${pathParms}`, reqData);

    },
    addCase(item) {
      this.addCaseModel = {
        data: item
      };
      this.addCaseVisible = true;
    },
    getReqData() {
      const ret = {
        ...this.formSearch
      };
      if (this.formSearch.offlineDays) {
        ret.offlineDays = [this.formSearch.offlineDays, 10000];
      }
      return ret;
    },
    getReqUrl() {
      return this.type === 1 ? apis.DmsDeviceOfflinePageOrg : apis.DmsDeviceOfflinePageMyself;
    },
    onTabChange(value) {
      this.$emit('tab', value);
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清除
    clearFilter: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
    getTableList() {
      const url = this.getReqUrl();
      const reqData = this.getReqData();
      this.$getJSON(url, reqData).then((res) => {
        this.tableList = res.data.records;
        this.totalRows = res.data.total;
      });
    }
  },
  created() {
  },
  mounted() {
    this.getTableColumn();
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
        if (!this.funcView.all_offline_device_list && this.funcView.my_offline_device_list) {
          this.onTabChange(2);
        }
      }, 500);
    });
    this.getTableList();
  },
};
</script>

<style lang="scss">
.offline-device-item {
  .tab {
    margin-left: -16px;
    margin-right: -16px;
  }
}
</style>
